import { makeStyles } from '@mui/styles';

export const useLoadingCounterStyles = makeStyles(() => ({
  loading_counter: {}
}));
